import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { saveAs } from 'file-saver';
import { CsvToHtmlTable } from 'react-csv-to-table';
import PageTitle from '../../../components/PageTitle';
import RouteNames from '../../App/RouteNames';
import TitleFrom from '../../../components/common/TitleFrom';
import { OperatorTenantDisputeSearchForm } from '../../../components/UsageHub';
import { DataTable, TablePagination, ModalWithItem, GenericInput } from '../../../components/common';
import {
  tabelColumnOperatorTenantDispute,
  sortOperatorTenantDispute,
  tabelColumnOperatorTenantDisputeById,
} from '../constants';
import { searchTenantDispute, getTenantDisputeById } from '../actions';
import { makeGetTenantDispute } from '../selectors';
import { getPageTotalCount, getBase64, splitF } from '../../../utils/utils';
import { makeGetS3Config } from '../../App/selectors';
import { readFileFromS3 } from '../../App/actions';

let fileSelect = null;
let pathSelect = null;
let idSelect = '';

class TenantDispute extends Component {
  state = {
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listOperatorTenantDispute: [],
    isOpenMdalDetails: false,
    itemDetails: [],
    pageItem: 0,
    sizeItem: 20,
    itemSelect: {},
    totalCountItem: null,
    base64File: null,
    isOpenMdalDownload: false,
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listOperatorTenantDispute: props.listOperatorTenantDispute,
      totalCount: getPageTotalCount({ ...state, items: props.listOperatorTenantDispute }),
    };
  }

  componentDidMount() {
    this.doSearchTenantDispute();
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doSearchTenantDispute();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doSearchTenantDispute());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doSearchTenantDispute());
  };

  onPageChangeItem = page => {
    const { pageItem } = this.state;
    if (pageItem === page) return '';
    this.setState({ pageItem: page }, () => this.doGetTenantDisputeById());
  };

  onSizeChangeItem = size => {
    this.setState({ sizeItem: size, page: 0 }, () => this.doGetTenantDisputeById());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doSearchTenantDispute();
    });
  };

  doSearchTenantDispute = () => {
    const { filter, page, size, sorted } = this.state;
    const { searchTenantDispute } = this.props;
    const payload = {
      page: page + 1,
      size,
      filter,
      sort: !isEmpty(sorted) ? sortOperatorTenantDispute[sorted.sortCol][sorted.sortDir] : null,
    };
    this.setState({ isSearching: true });
    searchTenantDispute(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doReadFileFromS3 = ({ config, path }) => {
    const { readFileFromS3 } = this.props;
    readFileFromS3({ ...config.data, url: path }, ({ success, data }) => {
      if (success) {
        fileSelect = data;
        pathSelect = path;
        this.handleFiles(data);
        getBase64(data, result => {
          this.setState({ base64File: result });
        });
      }
    });
  };

  downloadFile = path => {
    const { s3Config } = this.props;
    this.doReadFileFromS3({
      path,
      config: { data: s3Config },
    });
  };

  saveFileSelect = () => {
    saveAs(fileSelect, `${splitF(pathSelect)}`);
  };

  doGetTenantDisputeById = (id, item) => {
    idSelect = id || idSelect;
    const { pageItem, sizeItem, totalCountItem, itemSelect } = this.state;
    const { getTenantDisputeById } = this.props;
    const payload = {
      page: pageItem + 1,
      size: sizeItem,
      id: idSelect,
    };
    getTenantDisputeById(payload, ({ success, data }) => {
      if (success) {
        this.setState({
          itemDetails: data,
          isOpenMdalDetails: true,
          itemSelect: item || itemSelect,
          totalCountItem: getPageTotalCount({
            totalCount: totalCountItem || data.length,
            size: sizeItem,
            page: pageItem,
            items: data,
          }),
        });
      } else {
        this.setState({ itemDetails: [], isOpenMdalDetails: true, itemSelect: item });
      }
    });
  };

  handleFiles = () => {
    if (!fileSelect) return;
    const reader = new FileReader();
    reader.onload = () => this.setState({ isCsv: true, csvData: reader.result });
    reader.readAsText(fileSelect);
  };

  onCancelUploadFile = () => {
    this.setState({ isOpenUploadFile: false, itemSelect: null });
  };

  render() {
    const {
      isSearching,
      sorted,
      page,
      size,
      totalCount,
      listOperatorTenantDispute,
      isOpenMdalDetails,
      itemDetails,
      itemSelect,
      sizeItem,
      pageItem,
      totalCountItem,
      isOpenMdalDownload,
      csvData,
    } = this.state;
    const { t } = this.props;

    const newTabelColumnOperatorTenantDispute = [
      {
        name: 'id',
        label: 'common:label.id',
        render: (colName, item) => (
          <button
            type="button"
            className="btn btn-outline-success btn-sm no-border"
            onClick={() => this.doGetTenantDisputeById(item.id, item)}
          >
            {item.id}
          </button>
        ),
      },
      ...tabelColumnOperatorTenantDispute,
      {
        name: 'view',
        label: 'common:label.viewRecords',
        isRenderT: true,
        render: (colName, item, t) => (
          <button
            type="button"
            className="btn btn-outline-success btn-sm"
            onClick={() => this.doGetTenantDisputeById(item.id, item)}
          >
            {t('label.viewRecords')}
          </button>
        ),
      },
      {
        name: 'download',
        label: 'common:label.viewFiles',
        isRenderT: true,
        render: (colName, item, t) => (
          <button
            type="button"
            className="btn btn-outline-success btn-sm"
            disabled={!item.filePath}
            onClick={() => {
              this.downloadFile(item.filePath);
              this.setState({ isOpenMdalDownload: true });
            }}
          >
            {t('label.viewFiles')}
          </button>
        ),
      },
    ];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.invoiceUsage.path}
          titleBtn="back"
          items={[{ name: t('usagePage:sidebar.operator') }, { name: t('label.tenantDisputeFile') }]}
          isNoDefaultButton
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('label.tenantDisputeFile')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <OperatorTenantDisputeSearchForm onSubmit={this.onHandleSubmitSearch} />
              </div>
              <div>
                <br />
                <DataTable
                  columns={newTabelColumnOperatorTenantDispute}
                  data={listOperatorTenantDispute && listOperatorTenantDispute.length ? listOperatorTenantDispute : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>

        <ModalWithItem
          modalTitle={t('label.tenantDisputeFile')}
          isOpen={isOpenMdalDetails}
          wrapperClass="modal-custom modal-70 bd-example-modal-lg modal-selector"
          onToggle={() => {
            this.setState({ isOpenMdalDetails: false, itemDetails: [] });
          }}
        >
          <div className="col-md-12 row pb-3">
            <GenericInput
              value={itemSelect ? itemSelect.id : ''}
              wrapperClass="col-md-4"
              onChange={() => {}}
              name="fileId"
              readOnly
              label="label.fileId"
            />
            <GenericInput
              value={itemSelect ? itemSelect.fileName : ''}
              wrapperClass="col-md-4"
              onChange={() => {}}
              name="fileName"
              readOnly
              label="label.fileName"
            />
          </div>
          <DataTable
            columns={tabelColumnOperatorTenantDisputeById}
            data={itemDetails && itemDetails.length ? itemDetails : []}
            sorted={sorted}
            isLoading={isSearching}
          />
          <br />
          <TablePagination
            pageNumber={pageItem}
            pageSize={sizeItem}
            totalCount={totalCountItem}
            onPageChange={this.onPageChangeItem}
            onSizeChange={this.onSizeChangeItem}
          />
          <div className="text-right">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                this.setState({ isOpenMdalDetails: false, itemDetails: [] });
              }}
            >
              {t('common:label.cancel')}
            </button>
          </div>
          <br />
        </ModalWithItem>
        <ModalWithItem
          modalTitle={t('label.tenantDisputeFile')}
          isOpen={isOpenMdalDownload}
          onToggle={() => {
            this.setState({ isOpenMdalDownload: false });
          }}
        >
          <div className="col-md-12 d-flex p-0">
            <div>
              <button
                type="button"
                className="button x-small"
                onClick={() => {
                  this.setState({ isOpenMdalDownload: false });
                }}
              >
                {t('label.back')}
              </button>
            </div>
            <div className="group-btn-invoice text-right" style={{ width: '96%' }}>
              <button
                type="button"
                disabled={!csvData}
                className="button x-small"
                onClick={() => this.saveFileSelect()}
              >
                {t('label.download')}
              </button>
            </div>
          </div>
          <CsvToHtmlTable data={csvData} csvDelimiter="," tableClassName="table table-striped table-hover" />
        </ModalWithItem>
      </div>
    );
  }
}

TenantDispute.propTypes = {
  searchTenantDispute: PropTypes.func.isRequired,
  readFileFromS3: PropTypes.func.isRequired,
  getTenantDisputeById: PropTypes.func.isRequired,
};

TenantDispute.defaultProps = {};

const mapStateToProps = createStructuredSelector({
  listOperatorTenantDispute: makeGetTenantDispute() || [],
  s3Config: makeGetS3Config() || {},
});
export default withTranslation('common')(
  connect(mapStateToProps, { searchTenantDispute, readFileFromS3, getTenantDisputeById })(TenantDispute)
);
